import { Link, useLocation } from 'react-router-dom';

// Anchors resolve to homepage sections (or /home#<id> from other pages).
const Footer = () => {
  const location = useLocation();
  const isHome = location.pathname === '/' || location.pathname === '/home';
  const anchor = (a) => (isHome ? `#${a}` : `/home#${a}`);

  const muted = { color: '#8A90A2', textDecoration: 'none' };
  const colTitle = { fontFamily: "'Poppins', sans-serif", fontWeight: 600, fontSize: 14, marginBottom: 14, color: '#fff' };

  return (
    <footer className="px-6 py-12 min-[900px]:px-10 min-[900px]:pt-16 min-[900px]:pb-8" style={{ background: '#0C1120', color: '#fff' }}>
      <div style={{ maxWidth: 1180, margin: '0 auto' }}>
        <div
          className="grid grid-cols-2 gap-8 pb-10 min-[900px]:gap-9 min-[900px]:pb-11 min-[900px]:[grid-template-columns:1.4fr_1fr_1fr_1fr]"
          style={{ borderBottom: '1px solid rgba(255,255,255,.1)' }}
        >
          {/* Brand */}
          <div className="col-span-2 min-[900px]:col-span-1">
            <Link to="/"><img src="/assets/website/horizontal-white.png" alt="Shootzu" style={{ height: 42, width: 'auto', display: 'block' }} /></Link>
            <p style={{ fontSize: 14.5, color: '#8A90A2', lineHeight: 1.6, margin: '18px 0 0', maxWidth: '34ch' }}>
              Australia's professional network for photo and video crew. Find Crew, Be Crew.
            </p>
          </div>

          {/* Platform */}
          <div>
            <div style={colTitle}>Platform</div>
            <div className="flex flex-col" style={{ gap: 11, fontSize: 14 }}>
              <a href={anchor('how')} style={muted}>How it works</a>
              <a href={anchor('audience')} style={muted}>Find Crew</a>
              <a href={anchor('audience')} style={muted}>Be Crew</a>
              <Link to="/crew" style={muted}>Meet the Crew</Link>
              <a href={anchor('features')} style={muted}>Features</a>
              <Link to="/available-jobs" style={muted}>Available jobs</Link>
            </div>
          </div>

          {/* Company */}
          <div>
            <div style={colTitle}>Company</div>
            <div className="flex flex-col" style={{ gap: 11, fontSize: 14 }}>
              <Link to="/how-it-works" style={muted}>About</Link>
              <a href={anchor('faq')} style={muted}>FAQ</a>
              <a href="mailto:support@shootzu.com" style={muted}>Contact</a>
              <a href="tel:1300450331" style={muted}>1300 450 331</a>
            </div>
          </div>

          {/* Follow */}
          <div>
            <div style={colTitle}>Follow</div>
            <div className="flex flex-col" style={{ gap: 11, fontSize: 14 }}>
              <a href="https://www.instagram.com/shootzu" target="_blank" rel="noopener noreferrer" style={muted}>Instagram</a>
              <a href="https://www.facebook.com/shootzu" target="_blank" rel="noopener noreferrer" style={muted}>Facebook</a>
              <a href="https://www.linkedin.com/company/shootzu" target="_blank" rel="noopener noreferrer" style={muted}>LinkedIn</a>
              <a href="https://www.youtube.com/@shootzu" target="_blank" rel="noopener noreferrer" style={muted}>YouTube</a>
            </div>
          </div>
        </div>

        <div className="flex flex-wrap items-center gap-x-5 gap-y-2 min-[900px]:justify-between" style={{ paddingTop: 26, fontSize: 13, color: '#8A90A2' }}>
          <span>© 2026 Shootzu by Turbo Productions · Melbourne, Australia</span>
          <div className="flex" style={{ gap: 22 }}>
            <Link to="/privacy" style={muted}>Privacy</Link>
            <Link to="/terms" style={muted}>Terms</Link>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
